import { Button, Space, Typography } from 'antd';
import * as React from 'react';
import DataTableButtonUtil from '../../shared/DataTable/DataTableButtonUtil';
import { Content } from 'antd/lib/layout/layout';
import DataTable, { DataTableColumnProps } from '../../shared/DataTable/DataTable';
import DataTableColumnUtil from '../../shared/DataTable/DataTableColumnUtil';
import PublicReportsApiService from '../../../api/PublicReportsApiService';
import { ArrowLeftOutlined } from '@ant-design/icons';
import HistoryUtil from '../../../utils/HistoryUtil';
import Routes from '../../../consts/Routes';
import AdminConsentForSalesAndLeasesDTO from '../../../models/AdminConsentForSalesAndLeasesDTO';

interface ConsentForSalesAndLeasesReportsProps {
}
interface ConsentForSalesAndLeasesState {
    tableColumns: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO>[];
}
class ConsentForSalesAndLeasesReports extends React.Component<ConsentForSalesAndLeasesReportsProps, ConsentForSalesAndLeasesState> {
    private dataReportTable: DataTable<AdminConsentForSalesAndLeasesDTO> | undefined;
    constructor(props: ConsentForSalesAndLeasesReportsProps) {
        super(props);
        this.state = {
            tableColumns: this.getTableColumns()
        };
    }
    render() {
        const actionButtons = [];
        actionButtons.push(DataTableButtonUtil.Reset());
        return (
            <Content className="content-pad">
                <DataTable
                    ref={(element: any) => (this.dataReportTable = element)}
                    serverSide={true}
                    tableProps={{
                        rowKey: 'consentForSalesAndLeasesId',
                        sortDirections: ['ascend', 'descend'],
                        locale: {
                            emptyText: 'Currently there are no Consent for Sales and Leases reports to view'
                        }
                    }}
                    globalSearch={true}
                    buttonBar={actionButtons}
                    columns={this.state.tableColumns}
                    fetchData={{
                        fetch: function (tableRequest) {
                            return PublicReportsApiService.getConsentForSaleAndLeases(tableRequest);
                        },
                        failureMessage: 'Failure to retrieve Consent for Sales and Leases'
                    }}
                    styleOptions={{ compact: true, alternatingRowHighlight: true }}
                    title={
                        <Button type="link" onClick={() => HistoryUtil.push(Routes.generate(Routes.PUBLIC_REPORTS))}>
                            <Typography.Title level={4}>
                                <Space size="large">
                                    <ArrowLeftOutlined className="public-report-links" /> Consent for Sales/Leases
                                </Space>
                            </Typography.Title>
                        </Button>
                    }
                />
            </Content>
        );
    }

    private getTableColumns() {
        const columns: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO>[] = [];

        const columnOfficialName: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO> = DataTableColumnUtil.Text('Individual', 'name');
        columns.push(columnOfficialName);

        const columnOriginalExecutiveBranchAgencyName: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO> =
            DataTableColumnUtil.Text('Agency Name', 'agency');
        columns.push(columnOriginalExecutiveBranchAgencyName);

        const columnDateOfSale: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO> =
            DataTableColumnUtil.Date('Date of Sale', 'saleDate', null, { defaultSortOrder: 'descend' });;
        columns.push(columnDateOfSale);

        const columnSaleAmount: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO> = DataTableColumnUtil.Currency('Sale Amount', 'saleAmount');
        columns.push(columnSaleAmount);

        const columnSaleDescription: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO> =
            DataTableColumnUtil.Text('Description of Sale', 'saleDescription');
        columns.push(columnSaleDescription);

        const buttons = [
            { text: 'View', onClick: (rowData: AdminConsentForSalesAndLeasesDTO) => window.open(rowData.fileUrl || null || '') },
        ];

        const columnButtons: DataTableColumnProps<AdminConsentForSalesAndLeasesDTO> =
            DataTableColumnUtil.Buttons('consentForSalesAndLeasesId', buttons, 220);
        columns.push(columnButtons);

        return columns as DataTableColumnProps<AdminConsentForSalesAndLeasesDTO>[];
    }
}
export default ConsentForSalesAndLeasesReports;